/* istanbul ignore file */
import { useFinanceUrl } from 'domain/people/employee/finance/financeRouting';
import { LinkButton, LinkButtonProps } from 'framework/ui/ui-builder';

const ViewFinanceButton = (props: Omit<LinkButtonProps, 'url'>) => {
  const { getSingleEntityUrl } = useFinanceUrl();

  return (
    <LinkButton url={getSingleEntityUrl} variant="outlined" {...props}>
      View
    </LinkButton>
  );
};

export default ViewFinanceButton;
